import cbRadio from './faces/cbRadio.webp'
import hulaDancer from './faces/hulaDancer.webp'
import puppy from './faces/puppy.webp'
import ratchetStrap from './faces/ratchetStrap.webp'
import reflector from './faces/reflector.webp'
import trafficCone from './faces/trafficCone.webp'

export interface AgentFace {
  name: string
  src: string
}

/** Characters the fleet can give the agent, in the order they are offered. */
export const AGENT_FACES: AgentFace[] = [
  { name: 'Reflector', src: reflector },
  { name: 'CB radio', src: cbRadio },
  { name: 'Ratchet strap', src: ratchetStrap },
  { name: 'Traffic cone', src: trafficCone },
  { name: 'Hula dancer', src: hulaDancer },
  { name: 'Puppy', src: puppy },
]

export const DEFAULT_FACE = AGENT_FACES[0].src
